"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
exports.POSTAL_CODE_REGEXP = /^[1-9]{1}\d{2} ?\d{2}$/;
exports.postalCodeValidator = {
    name: 'postalCode',
    validation: function (value) {
        if (utils_1.isEmpty(value))
            return true;
        return exports.POSTAL_CODE_REGEXP.test(value);
    },
    formatter: function (value) {
        var newValue = value;
        if (newValue.length === 5) {
            newValue = value.substring(0, 3) + " " + value.substring(3, 5);
        }
        return newValue;
    },
};
//# sourceMappingURL=PostalCodeValidator.js.map